<template>
  <main class="container-fluid p-0">
    <section class="container px-0 px-md-3">
      <Header />
      <Main />
    </section>

    <section class="bg-white mt-5 mb-5">
      <PartnerMedia />
    </section>

    <section class="container mt-5">
      <Articles />
    </section>
    
    <section class="container mt-5">
      <hr class="my-5" style="background: rgba(255, 255, 255, 0.5);">
      <div class="row">
        <div class="col-12 col-md-6"><a href="https://www.masterdelcornicione.it"
            target="_blank"><img width="100%"
              src="https://images.squarespace-cdn.com/content/v1/6322d0b330590869c5fafe4c/e4456c18-d542-4421-9390-20017aaa6a9b/MASTER_ADV-05.png?format=750w"></a>
        </div>
        <div class="col-12 col-md-6 d-none d-md-block">
            <a href="https://www.masterdelcornicione.it" target="_blank">
              <img width="100%"
                src="https://images.squarespace-cdn.com/content/v1/6322d0b330590869c5fafe4c/7f6797b3-aedb-48bf-8510-e4106827e692/masterdelcornicione.png?format=1000w"></a>
            <span class="text-white mt-3 d-block" style="font-family: Playfair Display, serif; font-size: 24px;">
              <b style="color: rgb(239, 186, 40);">Farina Vesuvio</b> è l'ingrediente segreto per creare a casa una pizza
              napoletana con un <b style="color: rgb(239, 186, 40);">cornicione alto, soffice e
                perfettamente alveolato</b>, grazie al germe di grano vitale macinato a pietra.
            </span>
        </div>
      </div>
    </section>

    <footer class="container-fluid d-flex align-items-end p-0">
      <EndSite />
    </footer>
  </main>
</template>

<script>
import Header from '../components/Header.vue'
import Main from '../components/Main.vue'
import Judges from '../components/Judges.vue'
import PartnerMedia from '../components/PartnerMedia.vue'
import Articles from '../components/Articles.vue'
import EndSite from '../components/EndSite.vue'


export default {
  name: 'app',
  metaInfo: {
    htmlAttrs: {
      lang: 'it-IT'
    },
    meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1, maximum-scale=1' }
    ]
  },
  components: {
    Header,
    Main,
    Judges,
    PartnerMedia,
    Articles,
    EndSite
  },
  data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Libre+Franklin:wght@100;400;700&family=Playfair+Display:ital@1&display=swap');
@import '../../node_modules/@braid/vue-formulate/themes/snow/snow.scss';

body {
  background: linear-gradient(180deg, rgba(213, 19, 23, 1) 50%, rgba(171, 21, 25, 1) 100%);
  color: #fff;
  font-family: 'Libre Franklin', sans-serif;
}

main {
  background-image: url('../assets/wave2.svg');
  background-repeat: no-repeat;
}

.bg {
  position: absolute;
  top: -20px;
}

p:last-child {
  margin-bottom: 0;
}

p {
  font-weight: 500;
  font-size: 18px;
  margin-bottom: 35px;
  line-height: 1.7;
}

ul,
ol {
  font-weight: 500;
  font-size: 18px;
  margin-bottom: 35px;
  line-height: 1.7;
  padding-left: 25px;
}

.nav-pills .nav-link {
  border-radius: .25rem;
  font-size: 16px;
}

h1,
h2,
h3,
h4 {
  font-weight: bold;
}

a {
  color: #212529;
}

a:hover {
  color: #D51317;
  text-decoration: none;
}

.sing {
  font-family: 'Dancing Script', cursive;
}


// Extra small devices (portrait phones, less than 576px)
@media (min-width: 575.98px) {
  main {
    background-size: 620%;
  }
}

// Small devices (landscape phones, less than 768px)
@media (min-width: 767.98px) {
  main {
    background-size: 285%;
  }
}

// Medium devices (tablets, less than 992px)
@media (min-width: 991.98px) {
  main {
    background-size: 220%;
  }
}

// Large devices (desktops, less than 1200px)
@media (min-width: 1199.98px) {
  main {
    background-size: 185%;
  }
}

// Large devices (desktops, less than 1200px)
@media (min-width: 1499.98px) {
  main {
    background-size: 140%;
  }
}

@media (min-width: 1699.98px) {
  main {
    background-size: 125%;
  }
}

@media (min-width: 1999.98px) {
  main {
    background-size: 100%;
  }
}</style>



// WEBPACK FOOTER //
// src/views/Home.vue